import { siteStats, scoreDistribution } from "@/mocks/fengchiData";

export default function StatsOverview() {
  return (
    <section id="overview" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium">
            <i className="ri-donut-chart-line" />
            口碑总览
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            三分钟看懂风驰影院的口碑基本盘
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            先把整体情况摆在前面：目前收录 42 部作品，累计收到约 128 万条评分。
            下面这组数字可以帮你迅速判断——风驰影院的作品大致处在什么水平，以及观众的评价是集中在高分区，还是分散在中间地带。
          </p>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${stat.icon} text-xl`} />
              </span>
              <p className="mt-3 md:mt-4 text-xs md:text-sm text-foreground-500">{stat.label}</p>
              <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-none mt-1">
                {stat.value}
                <span className="text-sm md:text-base font-normal text-foreground-600 ml-1">
                  {stat.unit}
                </span>
              </p>
            </div>
          ))}
        </div>

        <div className="mt-6 md:mt-8 rounded-lg border border-background-200 bg-background-50 p-5 md:p-8">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
            <div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                评分分布：观众都打了几分
              </h3>
              <p className="text-sm text-foreground-600 mt-1">
                近七成评分落在 8.0 分及以上，说明整体口碑偏正向。
              </p>
            </div>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm">
              <i className="ri-emotion-happy-line" />
              整体评价：值得一看
            </span>
          </div>

          <div className="mt-6 space-y-4">
            {scoreDistribution.map((item, index) => (
              <div key={item.range} className="flex items-center gap-3 md:gap-4">
                <span className="w-[92px] md:w-[120px] shrink-0 text-xs md:text-sm text-foreground-700">
                  {item.range}
                </span>
                <div className="flex-1 h-2.5 md:h-3 rounded-full bg-background-200 overflow-hidden">
                  <div
                    className={`h-full rounded-full origin-left animate-growWidth ${
                      index <= 1 ? "bg-primary-500" : "bg-secondary-500"
                    }`}
                    style={{ width: `${item.percent}%`, animationDelay: `${index * 90}ms` }}
                  />
                </div>
                <span className="w-[52px] md:w-[64px] shrink-0 text-right text-xs md:text-sm text-foreground-600">
                  {item.percent}%
                </span>
                <span className="hidden sm:block w-[70px] shrink-0 text-right text-xs text-foreground-400">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}